import { tw } from "@careinfo/tailwind";

export default function () {
  return (
    <div
      className={tw`border-b-2 h-[4rem] border-gray-200 py-4  text-sm space-y-2`}
    >
      <div className={tw`flex items-center justify-start gap-x-3`}>
        <span
          className={tw`w-[15ch] animate-pulse inline-block h-[1ch] rounded-md bg-gray-500`}
        ></span>
        <span
          className={tw`w-[8ch] animate-pulse inline-block h-[1ch] rounded-md bg-gray-500`}
        ></span>
      </div>
      <div className={tw`flex items-center justify-start gap-x-3`}>
        <span
          className={tw`w-[5ch] animate-pulse inline-block h-[1ch] rounded-md bg-gray-500`}
        ></span>
        :
        <p>
          <span
            className={tw`w-[5ch] animate-pulse inline-block h-[1ch] rounded-md bg-gray-500`}
          ></span>
          -&gt;{" "}
          <span
            className={tw`w-[5ch] animate-pulse inline-block h-[1ch] rounded-md bg-gray-500`}
          ></span>
        </p>
      </div>
    </div>
  );
}
